/* APEXCORSE 7.3 — quantity=0 and remove-item cart repair.
   Uses Shopify Cart Ajax API with stable cart line keys and restores the drawer after a safe refresh. */
(function () {
  'use strict';
  var busy = false;
  var restoreKey = 'apexcorse-cart-drawer-restore-73';

  function getChangeUrl() {
    var themePath = window.Theme && window.Theme.routes && window.Theme.routes.cart_change_url;
    if (themePath) return themePath;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.replace(/\/?$/, '/') + 'cart/change.js';
  }

  function cartErrorLabel() {
    var labels = document.querySelector('[data-apex-cart-update-error]');
    return labels && labels.dataset.apexCartUpdateError || "We couldn't update your cart. Please try again.";
  }

  function displayError(row, message) {
    var cell = row.querySelector('.cart-items__quantity');
    if (!cell) return;
    var notice = cell.querySelector('.apex-cart-fix-error');
    if (!notice) {
      notice = document.createElement('p');
      notice.className = 'apex-cart-fix-error';
      notice.setAttribute('role', 'alert');
      notice.style.cssText = 'font-size:12px;line-height:1.4;color:#d10d25;margin:8px 0';
      cell.appendChild(notice);
    }
    notice.textContent = message || cartErrorLabel();
  }

  async function changeQuantity(row, quantity) {
    if (busy || !row || !row.dataset.key || !Number.isSafeInteger(quantity) || quantity < 0) return;
    busy = true;
    var control = row.querySelector('.cart-items__quantity-controls');
    var input = row.querySelector('input[data-cart-line]');
    if (control) control.setAttribute('aria-busy', 'true');
    if (input) input.readOnly = true;
    var restore = !!row.closest('#cart-drawer[open]');
    try {
      var response = await fetch(getChangeUrl(), {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: row.dataset.key, quantity: quantity })
      });
      var json = await response.json();
      if (!response.ok || json.errors) {
        throw new Error(typeof json.errors === 'string' ? json.errors : json.description || cartErrorLabel());
      }
      if (restore) {
        try { sessionStorage.setItem(restoreKey, '1'); } catch (error) { /* blocked storage */ }
      }
      window.location.reload();
    } catch (error) {
      console.warn('[APEXCORSE cart fix] Cart API failed:', error);
      displayError(row, error && error.message);
      busy = false;
      if (control) control.removeAttribute('aria-busy');
      if (input) input.readOnly = false;
    }
  }

  function getRow(element) {
    return element && element.closest('.cart-items__table-row[data-key]');
  }

  document.addEventListener('click', function (event) {
    var target = event.target instanceof Element ? event.target : event.target && event.target.parentElement;
    var control = target && target.closest('[data-apex-cart-remove], [data-apex-cart-minus]');
    if (!control || control.disabled || control.hidden) return;
    var row = getRow(control);
    if (!row || !row.closest('cart-items-component')) return;
    event.preventDefault();
    if (busy) return;

    if (control.hasAttribute('data-apex-cart-remove')) {
      changeQuantity(row, 0);
      return;
    }
    var input = row.querySelector('input[data-apex-cart-input]');
    if (!input || input.disabled) return;
    var current = parseInt(input.value, 10);
    var step = parseInt(input.step, 10) || 1;
    var minAllowed = parseInt(input.dataset.min, 10) || 1;
    if (!Number.isFinite(current) || current <= 0) return;
    var next = current - step;
    changeQuantity(row, next < minAllowed ? 0 : next);
  }, true);

  document.addEventListener('blur', function (event) {
    var input = event.target;
    if (!(input instanceof HTMLInputElement) || !input.hasAttribute('data-apex-cart-input')) return;
    var row = getRow(input);
    if (!row || busy || input.disabled) return;
    var desired = parseInt(input.value, 10);
    var previous = parseInt(input.defaultValue, 10);
    if (!Number.isFinite(desired) || desired < 0) {
      input.value = String(previous > 0 ? previous : 1);
      return;
    }
    var minAllowed = parseInt(input.dataset.min, 10) || 1;
    var maxAllowed = parseInt(input.max, 10);
    if (desired > 0 && desired < minAllowed) desired = minAllowed;
    if (Number.isFinite(maxAllowed) && maxAllowed > 0) desired = Math.min(desired, maxAllowed);
    if (desired === previous) { input.value = String(desired); return; }
    changeQuantity(row, desired);
  }, true);

  document.addEventListener('keydown', function (event) {
    var input = event.target;
    if (event.key === 'Enter' && input instanceof HTMLInputElement && input.hasAttribute('data-apex-cart-input')) {
      event.preventDefault();
      input.blur();
    }
  }, true);

  function restoreDrawerIfNeeded() {
    try {
      if (sessionStorage.getItem(restoreKey) !== '1') return;
      sessionStorage.removeItem(restoreKey);
    } catch (error) { return; }
    customElements.whenDefined('theme-drawer').then(function () {
      var drawer = document.getElementById('cart-drawer');
      if (drawer && typeof drawer.open === 'function' && !drawer.hasAttribute('open')) {
        drawer.open();
      }
    }).catch(function () {});
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', restoreDrawerIfNeeded, { once: true });
  else restoreDrawerIfNeeded();
})();